import React from "react";
import { DeliveryType } from "@wayke-se/ecom";
import StoreAction from "../constants/store-action";
import UserEvent from "../constants/user-event";
import DeliveryMethodItem from "./delivery-method-item";
import { isAvailable } from "../utils/delivery";
import CustomerInformationInputType from "../constants/customer-information-input-type";
import { getRetailerInformation } from "../utils/retailer";
const getUserEventFromDeliveryType = (type) => {
    switch (type) {
        case DeliveryType.Pickup:
            return UserEvent.DELIVERY_TYPE_PICKUP_CHOSEN;
        case DeliveryType.Delivery:
            return UserEvent.DELIVERY_TYPE_DELIVERY_CHOSEN;
        default:
            return null;
    }
};
const sort = [DeliveryType.Delivery, DeliveryType.Pickup];
export default (props) => {
    const onMethodClick = (deliveryOption) => {
        props.dispatchStoreAction(StoreAction.INTERACT_UPDATE_SPECIFIC, {
            type: "delivery",
            name: "type",
        });
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "delivery",
            name: "type",
            value: deliveryOption.type,
        }, () => {
            const userEvent = getUserEventFromDeliveryType(deliveryOption.type);
            if (userEvent !== null)
                props.onIncompleteUserEvent(userEvent);
            props.onProceedToNextStep();
        });
    };
    const onSkipDeliveryType = () => {
        props.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
            type: "delivery",
            name: "type",
            value: DeliveryType.None,
        }, () => {
            const userEvent = getUserEventFromDeliveryType(DeliveryType.None);
            if (userEvent !== null)
                props.onIncompleteUserEvent(userEvent);
            props.onProceedToNextStep();
        });
    };
    const address = props.getAddress();
    const isAutomaticAddress = props.data.customer.inputType == CustomerInformationInputType.AUTOMATIC;
    const items = props.orderOptions
        .getDeliveryOptions()
        .sort((a, b) => sort.indexOf(a.type) - sort.indexOf(b.type))
        .map((option) => (React.createElement(DeliveryMethodItem, Object.assign({ key: option.type, address: address, deliveryOption: option, onDeliveryOptionClick: onMethodClick }, props))));
    const hasAvailableOptions = props.orderOptions
        .getDeliveryOptions()
        .filter((option) => isAvailable(option, address, isAutomaticAddress)).length > 0;
    const retailerInformation = getRetailerInformation(props.orderOptions);
    const retailerName = !!retailerInformation
        ? retailerInformation.name
        : "Handlaren";
    return (React.createElement("div", { className: "page-main" },
        React.createElement("section", { className: "page-section" },
            React.createElement("h1", { className: "h6" }, "Leverans"),
            React.createElement("div", { "data-ecom-content": "" },
                React.createElement("p", null,
                    retailerName,
                    " erbjuder \u00E4ven hemleverans till din adress. V\u00E4lj nedan hur du vill ha din nya bil levererad."))),
        React.createElement("section", { className: "page-section" },
            React.createElement("div", { "data-ecom-optionlist": "" },
                React.createElement("ul", { className: "option-list" }, items))),
        !hasAvailableOptions && (React.createElement("section", { className: "page-section page-section-bottom" },
            React.createElement("div", { "data-ecom-buttonnav": "" },
                React.createElement("div", { className: "button-nav-item" },
                    React.createElement("button", { "data-ecom-button": "full-width", onClick: onSkipDeliveryType }, "Forts\u00E4tt utan leveranss\u00E4tt")))))));
};
